"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.object.assign.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.search.js");
var _jsxRuntime = require("react/jsx-runtime");
var _react = require("react");
var _material = require("@mui/material");
var _TableTextSearchBox = _interopRequireDefault(require("./TableTextSearchBox"));
var _TableRangeSearchBox = _interopRequireDefault(require("./TableRangeSearchBox"));
var _TableSelectSearchBox = _interopRequireDefault(require("./TableSelectSearchBox"));
var _types = require("./types");
var _TableDateSearchBox = _interopRequireDefault(require("./TableDateSearchBox"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var __extends = void 0 && (void 0).__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return _extendStatics(d, b);
  };
  return function (d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    _extendStatics(d, b);
    function __() {
      this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();
var __assign = void 0 && (void 0).__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var EnhancedTableHead = /** @class */function (_super) {
  __extends(EnhancedTableHead, _super);
  function EnhancedTableHead(props) {
    var _this = this;
    var _a;
    _this = _super.call(this, props) || this;
    _this.createSortHandler = function (propertyIdx) {
      return function (event) {
        _this.props.onRequestSort(event, propertyIdx);
      };
    };
    _this.onClearSearch = function (columnTitle) {
      var searchTerms = __assign({}, _this.state.searchTerms);
      delete searchTerms[columnTitle];
      _this.setState({
        searchTerms: searchTerms
      });
      _this.props.onSearch(searchTerms);
    };
    _this.state = {
      searchTerms: (_a = _this.props.defaultColumnSearchTerms) !== null && _a !== void 0 ? _a : {}
    };
    return _this;
  }
  EnhancedTableHead.prototype.componentDidUpdate = function (prevProps) {
    if (prevProps.defaultColumnSearchTerms !== this.props.defaultColumnSearchTerms) {
      this.setState({
        searchTerms: this.props.defaultColumnSearchTerms
      });
    }
  };
  EnhancedTableHead.prototype.isColumnRemote = function (column) {
    return this.props.mode === 'remote';
  };
  EnhancedTableHead.prototype.onSearchChange = function (newSearch, column) {
    var _a;
    var _this = this;
    var searchTerms = __assign(__assign({}, this.state.searchTerms), (_a = {}, _a[column] = newSearch, _a));
    this.setState({
      searchTerms: searchTerms
    }, function () {
      return _this.props.onSearch(searchTerms);
    });
  };
  EnhancedTableHead.prototype.getSearchTermAsString = function (value) {
    if (typeof value === 'string') {
      return value;
    }
    return ''; // Convert all other types to an empty string
  };

  EnhancedTableHead.prototype.getSearchTermAsInterval = function (value) {
    if (typeof value !== 'string' && value != null && !Array.isArray(value)) {
      return value;
    }
    return null; // Convert all other types to null
  };

  EnhancedTableHead.prototype.getSearchTermAsArray = function (value) {
    if (Array.isArray(value) && value.length >= 2) {
      return value;
    }
    return ['', '']; // Convert all other types to an empty array
  };

  EnhancedTableHead.prototype.handleCustomColumn = function (searchOption, column, columnIdx) {
    var _this = this;
    var _a, _b, _c, _d, _e, _f, _g;
    if (this.isColumnRemote(column) && (typeof column.remoteField !== 'string' || column.remoteField === '')) {
      return (0, _jsxRuntime.jsx)(_material.TableCell, {}, columnIdx);
    }
    switch (searchOption) {
      case 'range':
        return (0, _jsxRuntime.jsx)(_material.TableCell, __assign({
          align: "left",
          padding: "normal",
          sortDirection: this.props.orderByIdx === columnIdx ? this.props.order : undefined,
          sx: {
            width: "".concat(column.widthPercent, "%"),
            minWidth: "".concat(column.minWidth, "px")
          }
        }, {
          children: (0, _jsxRuntime.jsx)(_TableRangeSearchBox.default, {
            handleUpdateValue: function handleUpdateValue(newValue) {
              return _this.onSearchChange({
                searchType: _types.ColumnLevelSearchOption.RANGE,
                searchValue: newValue
              }, column.title);
            },
            defaultMinValue: this.getSearchTermAsArray((_a = this.state.searchTerms[column.title]) === null || _a === void 0 ? void 0 : _a.searchValue)[0],
            defaultMaxValue: this.getSearchTermAsArray((_b = this.state.searchTerms[column.title]) === null || _b === void 0 ? void 0 : _b.searchValue)[1]
          })
        }), columnIdx);
      case 'column':
        return (0, _jsxRuntime.jsx)(_material.TableCell, __assign({
          align: "left",
          padding: "normal",
          sortDirection: this.props.orderByIdx === columnIdx ? this.props.order : false,
          sx: {
            width: "".concat(column.widthPercent, "%"),
            minWidth: "".concat(column.minWidth, "px")
          }
        }, {
          children: (0, _jsxRuntime.jsx)(_TableTextSearchBox.default, {
            handleUpdateValue: function handleUpdateValue(newValue) {
              _this.onSearchChange({
                searchType: 'column',
                searchValue: newValue
              }, column.title);
            },
            defaultValue: this.getSearchTermAsString((_c = this.state.searchTerms[column.title]) === null || _c === void 0 ? void 0 : _c.searchValue),
            variant: "outlined"
          })
        }), columnIdx);
      case 'select':
        if (this.props.columnSelectFilterOptions[column.title] != null) {
          return (0, _jsxRuntime.jsx)(_material.TableCell, __assign({
            align: "left",
            padding: "normal",
            sortDirection: this.props.orderByIdx === columnIdx ? this.props.order : false,
            sx: {
              width: "".concat(column.widthPercent, "%"),
              minWidth: "".concat(column.minWidth, "px")
            }
          }, {
            children: (0, _jsxRuntime.jsx)(_TableSelectSearchBox.default, {
              column: column,
              searchTerms: this.state.searchTerms,
              columnSelectFilterOptions: this.props.columnSelectFilterOptions,
              onSearchChange: function onSearchChange(newSearch, columnTitle) {
                return _this.onSearchChange(newSearch, columnTitle);
              }
            })
          }), columnIdx);
        } else {
          return (0, _jsxRuntime.jsx)(_material.TableCell, {}, columnIdx);
        }
      case 'date':
        return (0, _jsxRuntime.jsx)(_material.TableCell, __assign({
          align: "left",
          padding: "normal",
          sortDirection: this.props.orderByIdx === columnIdx ? this.props.order : undefined,
          sx: {
            width: "".concat(column.widthPercent, "%"),
            minWidth: "".concat(column.minWidth, "px")
          }
        }, {
          children: (0, _jsxRuntime.jsx)(_TableDateSearchBox.default, {
            handleUpdateValue: function handleUpdateValue(newValue) {
              return _this.onSearchChange({
                searchType: _types.ColumnLevelSearchOption.DATE,
                searchValue: newValue
              }, column.title);
            },
            defaultMinValue: (_e = this.getSearchTermAsInterval((_d = this.state.searchTerms[column.title]) === null || _d === void 0 ? void 0 : _d.searchValue)) === null || _e === void 0 ? void 0 : _e.start,
            defaultMaxValue: (_g = this.getSearchTermAsInterval((_f = this.state.searchTerms[column.title]) === null || _f === void 0 ? void 0 : _f.searchValue)) === null || _g === void 0 ? void 0 : _g.end
          })
        }), columnIdx);
      case 'none':
      default:
        return (0, _jsxRuntime.jsx)(_material.TableCell, {}, columnIdx);
    }
  };
  EnhancedTableHead.prototype.render = function () {
    var _this = this;
    var _a, _b, _c;
    return (0, _jsxRuntime.jsxs)(_material.TableHead, {
      children: [(0, _jsxRuntime.jsx)(_material.TableRow, {
        children: this.props.columns.map(function (column, columnIdx) {
          return (0, _jsxRuntime.jsx)(_material.TableCell, __assign({
            align: "left",
            padding: "normal",
            sortDirection: _this.props.orderByIdx === columnIdx ? _this.props.order : false,
            sx: {
              width: "".concat(column.widthPercent, "%"),
              minWidth: "".concat(column.minWidth, "px")
            }
          }, {
            children: (0, _jsxRuntime.jsx)(_material.TableSortLabel, __assign({
              active: _this.props.orderByIdx === columnIdx && !!(typeof column.value === 'function' || column.customSort),
              direction: _this.props.orderByIdx === columnIdx ? _this.props.order : _types.SortDirection.ASC,
              onClick: _this.createSortHandler(columnIdx),
              disabled: typeof column.value !== 'function' && !column.customSort || _this.isColumnRemote(column) && (typeof column.remoteField !== 'string' || column.remoteField === '') || column.disableSort === true
            }, {
              children: column.title
            }))
          }), columnIdx);
        })
      }), (((_a = this.props.columns) === null || _a === void 0 ? void 0 : _a.find(function (column) {
        return column.search === _types.ColumnLevelSearchOption.COLUMN;
      })) != null || ((_b = this.props.columns) === null || _b === void 0 ? void 0 : _b.find(function (column) {
        return column.search === _types.ColumnLevelSearchOption.RANGE;
      })) != null || ((_c = this.props.columns) === null || _c === void 0 ? void 0 : _c.find(function (column) {
        return column.search === _types.ColumnLevelSearchOption.SELECT;
      })) != null || this.props.searchType === _types.TableLevelSearchOption.COLUMN) && (0, _jsxRuntime.jsx)(_material.TableRow, {
        children: this.props.columns.map(function (column, columnIdx) {
          var _a;
          return _this.props.searchType === _types.TableLevelSearchOption.COLUMN && column.search == null ? _this.handleCustomColumn(_types.ColumnLevelSearchOption.COLUMN, column, columnIdx) : _this.handleCustomColumn((_a = column.search) !== null && _a !== void 0 ? _a : _types.ColumnLevelSearchOption.NONE, column, columnIdx);
        })
      })]
    });
  };
  return EnhancedTableHead;
}(_react.Component);
var _default = EnhancedTableHead;
exports.default = _default;